import store from '@/store';
import { PathComponentEnum } from '@/router/constants';

function getRouteLocale(route) {
  const routeLocale = route?.params?.locale;
  if (Array.isArray(routeLocale)) return routeLocale[0];
  if (routeLocale) return routeLocale;

  return localStorage.getItem('locale') || process.env.VUE_APP_I18N_LOCALE || 'ru';
}

export function moduleAccessMiddleware(to, _, next) {
  const disabledModuleRecord = to.matched.find((record) => {
    const moduleKey = record?.meta?.moduleKey;
    if (!moduleKey) return false;

    const defaultEnabled = record.meta.moduleDefaultEnabled !== false;

    return !store.getters['moduleConfig/isModuleEnabled'](moduleKey, defaultEnabled);
  });

  if (!disabledModuleRecord) {
    next();
    return;
  }

  next({
    name: PathComponentEnum.accessError,
    params: { locale: getRouteLocale(to) },
  });
}
